"use strict";

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DependencyContainer = void 0;

require("reflect-metadata");

var object_type_1 = require("./object-type");

var dependency_life_time_1 = require("./dependency-life-time");

var DependencyContainer = /*#__PURE__*/function () {
  function DependencyContainer(parent, collection, name) {
    _classCallCheck(this, DependencyContainer);

    this._scopedInstances = new Map();
    this._collection = collection;
    this._parent = parent;
    this.name = name;
  }

  _createClass(DependencyContainer, [{
    key: "createScopedInjector",
    value: function createScopedInjector(name) {
      return new DependencyContainer(this, this._collection, name);
    }
  }, {
    key: "resolve",
    value: function resolve(objectType) {
      try {
        if (objectType === DependencyContainer) return this; // this will throw if the object type is not registered.

        var descriptor = this._collection.get(objectType);

        switch (descriptor.lifeTime) {
          //////////////////////////////////////////////////////////////
          // Singletons
          //////////////////////////////////////////////////////////////
          // if the descriptor tells is a singleton we try to create
          // the instance or we return the instance we have.
          case dependency_life_time_1.DependencyLifeTime.Singleton:
            if (!descriptor.instance) descriptor.instance = this.createInstance(objectType, descriptor);
            return descriptor.instance;
          //////////////////////////////////////////////////////////////
          // Scoped
          //////////////////////////////////////////////////////////////
          // the scoped instances are scoped singletons, singletons that
          // live the scoped injector instead of the global scope

          case dependency_life_time_1.DependencyLifeTime.Scoped:
            if (this._parent === null) throw new Error("Can not instantiate a scoped type in the global container.");
            var instance = this.getInstance(objectType);

            if (!instance) {
              this._scopedInstances.set(objectType, this.createInstance(objectType, descriptor));

              return this._scopedInstances.get(objectType);
            }

            return instance;
          //////////////////////////////////////////////////////////////
          // Transient
          //////////////////////////////////////////////////////////////

          case dependency_life_time_1.DependencyLifeTime.Transient:
            return this.createInstance(objectType, descriptor);

          default:
            throw new Error("Life time parameter not recognized as a valid life time.");
        }
      } catch (e) {
        throw new Error("Couldn't instantiate the type ".concat(object_type_1.getObjectTypeName(objectType), ".\n - ").concat(e.message));
      }
    }
  }, {
    key: "createInstance",
    value: function createInstance(objectType, descriptor) {
      var _this = this;

      var parameters = [null].concat(descriptor.dependencies.map(function (x) {
        return _this.resolve(x);
      }));
      return new (Function.prototype.bind.apply(objectType, parameters))();
    }
  }, {
    key: "getInstance",
    value: function getInstance(objectType) {
      if (this._scopedInstances.has(objectType)) return this._scopedInstances.get(objectType);
      if (this._parent) return this._parent.getInstance(objectType);
      return null;
    }
  }], [{
    key: "createFromCollection",
    value: function createFromCollection(collection, name) {
      if (!collection) throw new Error("Can not create a dependency container without a dependency collection.");
      return new DependencyContainer(null, collection, name);
    }
  }]);

  return DependencyContainer;
}();

exports.DependencyContainer = DependencyContainer;